import { pushLocation } from '../timelineFilters'

export const connectionNavigation = {
  assign: (url: string) => {
    if (/^\/settings\/connections\/\d+$/.test(url)) {
      pushLocation(new URL(url, window.location.origin))
      return
    }
    window.location.assign(url)
  },
}

export function clearConnectionReturn() {
  const params = new URLSearchParams(window.location.hash.slice(1))
  if (!params.has('state') && !params.has('error')) return
  window.history.replaceState(
    window.history.state,
    '',
    window.location.pathname + window.location.search,
  )
}
